import { FC, ReactElement, Ref } from 'react';
import { Modal } from 'react-bootstrap';
import cn from '../../utils/classnames';
import Button from '../button/button';
import { GetFreeMaterialButtonConfigProps } from '../get-free-material-button/get-free-material-button';
import './shared-modal.scss';

type SharedModalProps = {
    onClose: () => void;
    title: ReactElement;
    body?: ReactElement;
    btnConfig?: GetFreeMaterialButtonConfigProps['buttonConfig'];
    closeButton?: boolean;
    dialogClassName?: string;
    subsection?: ReactElement;
    closeOnOutsideClick?: boolean | 'static';
};

const SharedModal: FC<SharedModalProps> = ({
    body,
    btnConfig,
    title,
    onClose,
    closeButton = true,
    dialogClassName = '',
    subsection,
    closeOnOutsideClick = 'static'
}) => (
    <Modal
        show
        backdrop={closeOnOutsideClick}
        backdropClassName='shared-backdrop'
        dialogClassName={cn('shared-modal', { [dialogClassName]: dialogClassName, 'empty-body': !body })}
        onHide={onClose}
        onClick={(event: React.MouseEvent) => event.stopPropagation()}
    >
        <Modal.Header closeButton={closeButton}>
            <div className='lmp-h-5 shared-modal-header'>{title}</div>
        </Modal.Header>

        {Boolean(body) && (
            <Modal.Body>
                <div>{body}</div>
            </Modal.Body>
        )}
        {Boolean(btnConfig?.length) && (
            <Modal.Footer>
                {btnConfig?.map((btn) => (
                    <Button
                        key={btn.text as string}
                        className={`${btn.className} float-right`}
                        disabled={btn.disabled}
                        onClick={btn.action}
                    >
                        {btn.text}
                    </Button>
                ))}
            </Modal.Footer>
        )}
        {subsection}
    </Modal>
);

export default SharedModal;
